import React from 'react';
import { combineClassNames, getMediaPath } from '../../../../app/functions';
import allCategoriesIcon from '../../../../assets/icons/all-categories.svg';
import './index.scss';

const CategoryItem = ({ data, isSelected = false, onCategoryClick = () => {} }) => {
    const categoryName = data.title || data.name || data.text;
    const categoryIcon = data.media_path || data.sliderMediaPath;

    const handleClickEvent = () => onCategoryClick(data.id);

    return (
        <div
            className="shared-category-item"
            onClick={handleClickEvent}
        >
            <div className="category-icon-container">
                <img
                    src={categoryIcon ? getMediaPath(categoryIcon) : allCategoriesIcon}
                    alt={categoryName}
                    className="category-icon"
                />
            </div>

            <span
                className={combineClassNames(
                    'category-title',
                    isSelected && 'category-title_selected-category',
                )}
            >
            {categoryName}
        </span>

            <div
                className={combineClassNames(
                    'category-underline',
                    isSelected && 'category-underline_visible',
                )}
            />
        </div>
    );
};

export default CategoryItem;
